import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { FileDownload } from '@omega-energia/react';
import { CircularProgress, Typography } from '@material-ui/core';
import classNames from 'classnames';
import { ParceirosParametros } from './ParceirosParametros/ParceirosParametros';
import { INITIAL_FILTER_STATE, INITIAL_SORT_STATE } from './ParceirosTableConstants';
import { useAuth } from '../../../../auth/authProvider';
import request from '../../../../services/network/request';
import ParceirosParametrosTable from './ParceirosParametros/ParceirosParametrosTable';

const Parceiros = () => {
  const { token } = useAuth();
  const [tableData, setTableData] = useState([]);
  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [filters, setFilters] = useState(INITIAL_FILTER_STATE);
  const [debouncedPartnerFilter, setDebouncedPartnerFilter] = useState(INITIAL_FILTER_STATE.partner);
  const [sorts, setSorts] = useState(INITIAL_SORT_STATE);
  const [selectedFilter, setSelectedFilter] = useState(undefined);
  const [parcelasFilter, setParcelasFilter] = useState('');

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setDebouncedPartnerFilter(filters.partner);
    }, 400);

    return () => clearTimeout(timeoutId);
  }, [filters.partner]);

  const parseValues = obj => {
    const values = Object.entries(obj).map(item => {
      return item[1] ? `${item[0]}:${item[1]}` : '';
    });
    return values.filter(term => term !== '').join(',');
  };

  const queryFilters = {
    ...filters,
    partner: debouncedPartnerFilter,
  };

  const { isFetching: isLoading, refetch } = useQuery(
    ['fetch-invoices-bs', currentPage, rowsPerPage, queryFilters, sorts],
    () => {
      const { parcelas, ...mainFilters } = queryFilters;
      const params = {
        sort: parseValues(sorts),
        page: currentPage,
        take: rowsPerPage,
        filters: parseValues(mainFilters),
      };
      return request.get('backstage/comunidade/invoices', { token, params });
    },
    {
      onSuccess: data => {
        setTableData([...data.content]);
        setTotal(data.total);
        setCurrentPage(data.currentPage);
      },
    },
  );

  const handleChangePage = (_, newPage) => {
    setCurrentPage(newPage);
  };

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(1);
  };

  const handleDownloadInvoices = async () => {
    const { parcelas, ...mainFilters } = filters;
    const params = {
      filters: parseValues(mainFilters),
      sort: parseValues(sorts),
    };

    const file = await request.get('backstage/comunidade/invoices/download', {
      token,
      params,
      responseType: 'arrayBuffer',
    });

    const blob = new Blob([new Uint8Array([0xef, 0xbb, 0xbf]), file], { type: 'text/csv' });

    FileDownload.downloadFile(blob, 'invoices');
  };

  const changeFilters = filter => {
    setCurrentPage(1);
    setFilters(filter);
  };

  const renderContent = () => {
    if (isLoading) {
      return (
        <div
          className={classNames.progressWrapper}
          style={{ height: '60%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <CircularProgress />
        </div>
      );
    }

    if (tableData.length === 0) {
      return <Typography>Ops. Não encontramos nada.</Typography>;
    }

    return (
      <ParceirosParametrosTable
        data={tableData}
        setParceiros={setTableData}
        setSorts={setSorts}
        sorts={sorts}
        total={total}
        rowsPerPage={rowsPerPage}
        currentPage={currentPage}
        handleChangePage={handleChangePage}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        refetch={refetch}
        parcelasFilter={parcelasFilter}
      />
    );
  };

  return (
    <>
      <ParceirosParametros
        handleDownloadInvoices={handleDownloadInvoices}
        filters={filters}
        setFilters={changeFilters}
        hasFastFilterSelected={!!selectedFilter}
        setSelectedFilter={setSelectedFilter}
        parcelasFilter={parcelasFilter}
        setParcelasFilter={setParcelasFilter}
      />
      {renderContent()}
    </>
  );
};

export { Parceiros };
